import { render, staticRenderFns } from "./logisticsDetail.vue?vue&type=template&id=8b6fb176&scoped=true&"
import script from "./logisticsDetail.vue?vue&type=script&lang=js&"
export * from "./logisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDetail.vue?vue&type=style&index=0&id=8b6fb176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6fb176",
  null
  
)

export default component.exports